// import { useState, useEffect } from "react";
// import { plantSldApi, sldApi } from "../../../../../../api/Api";
// import { PASS_KEY, WEB_KEY } from "../../../../../../api/AxiosApi";

// export default function Tab10SldPlant() {
//     const [logData, setLogData] = useState(null);
//     const [loading, setLoading] = useState(false); // Loading state

//     const credentials = {
//         LOGIN_ID: sessionStorage.getItem("LoginID"),
//         LOC_CODE: sessionStorage.getItem("LCODE"),
//         PASS_KEY: PASS_KEY,
//         WEB_KEY: WEB_KEY,
//     };

//     useEffect(() => {
        
//         fetchLogData(); // Initial call

//         const interval = setInterval(() => {
//             fetchLogData();
//         }, 40000); // 40 seconds

//         return () => clearInterval(interval); // Cleanup on unmount
//     }, []);

//     const fetchLogData = async () => {
//         console.clear(); // clear console before fetching
//         setLoading(true); // Start loading
//         try {
//             const imageUrl = await plantSldApi(credentials);
//             setLogData(imageUrl);
//         } catch (error) {
//             // console.error("Error fetching log data:", error);
//             setLogData(null);
//         } finally {
//             setLoading(false); // Stop loading
//         }
//     };

    

//     // console.log("sldplantlog", logData)
//     return (
//         <div className="row">
//             {logData ? (
//                 <iframe
//                     src={logData}
//                     width="100%"
//                     height="600px"
//                     title="SLD PDF"
//                 />
//             ) : (
//                 <p>No pdf available</p>
//             )}

//         </div>
//     );
// }


import { useState, useEffect } from "react";
import { plantSldApi } from "../../../../../../api/Api";
import { PASS_KEY, WEB_KEY } from "../../../../../../api/AxiosApi";

export default function Tab10SldPlant() {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const credentials = {
    LOGIN_ID: sessionStorage.getItem("LoginID"),
    LOC_CODE: sessionStorage.getItem("LCODE"),
    PASS_KEY,
    WEB_KEY,
  };

  const fetchLogData = async () => {
    setLoading(true);
    try {
      const url = await plantSldApi(credentials);
      setPdfUrl(url);
    } catch {
      setPdfUrl(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();

    const interval = setInterval(fetchLogData, 40000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="row">
      {loading && <p>Loading PDF...</p>}

      {!loading && pdfUrl ? (
        <iframe
          src={pdfUrl}
          width="100%"
          height="600px"
          title="SLD PDF"
        />
      ) : (
        !loading && <p>No PDF available</p>
      )}
    </div>
  );
}
